/**
 * Determine if an error is a service outage error
 * Applies to CF, DS, CloudStorage reqs.
 */

/**  Environment  */
import environmentVariables from '../util/environmentVariables';
environmentVariables();

/**  Imports  */
import { IToolboxRequestError } from '../../types/interfaces';

const SERVICE_OUTAGE_MESSAGES = [
    'econnrefused',
    'econnreset',
    'etimedout',
    'unavailable',
    'client network',
    'disconnected',
    'connection',
    'gateway',
    'timeout',
    'tls',
    'socket',
    'outage',
];

/**  Method  */
export default function isServiceOutage(
    error: IToolboxRequestError,
    { httpCloudFunctionRequest = false } = {}
): boolean {
    let parsed_message: Record<string, any> = {};
    try {
        parsed_message = JSON.parse(error?.message || '');
    } catch (err) {
        //  Ignore?
    }

    const status_code = parseInt(
        parsed_message.statusCode ||
            parsed_message.code ||
            error.statusCode ||
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            error.code ||
            500
    );

    let message = error.brief || parsed_message.message || error.message || '';
    message = typeof message === 'string' ? message.toLowerCase() : '';

    /**
     * Service outage errors:
     *  - ECONNREFUSED
     *  - ECONNRESET
     *  - UNAVAILABLE
     *  - "could not handle the request"
     *  - "Client network socket disconnected before secure TLS connection was established"
     *  - If we have a statusCode > 500, potentially a 503 'Service Unavailable' error
     *  - One type of Google service failure returns an HTML
     *    string with "500 Server Error" in it.
     *  - Other HTML-containing strings would also be suspect (httpCF only)
     */
    if (
        SERVICE_OUTAGE_MESSAGES.some(m => message.includes(m.toLowerCase())) ||
        (httpCloudFunctionRequest && message.includes('500 server error')) ||
        (httpCloudFunctionRequest && message.includes('could not handle the request')) ||
        (httpCloudFunctionRequest && message.includes('<html>')) ||
        (status_code > 500 && status_code <= 599) ||
        status_code === 429
    ) {
        return true;
    }

    return false;
}
